import SolrService from "./services/solrService";

angular.module('cfn').service('seedSearch.service', seedSearchService);
seedSearchService.$inject = ['$rootScope', '$log', '$q', '$http', '$sce', '$timeout'];

function seedSearchService($rootScope, $log, $q, $http, $sce, $timeout) {
  const SERVICE_BASE_URL = '/365FarmNet/mod/catalog-service/rest/v1.0/seeds/';
  const SYSSEED_SERVICE_BASE_URL = '/365FarmNet/mod/supply-service/rest/v1.0/seeds';
  const START_PAGE = 0;
  const DEFAULT_ROWS = 500;

  let seedSearchService = {
    search: search
  };

  return seedSearchService;


  // --- public methods --------------------------------------------------------------------------

  function search(item) {
    // start search only if term given that has a min length of 3
    if(!item || item === '' || item.length < 3) {
      let d = $q.defer();
      let resp = {
        searchString: item,
        results: []
      }

      $timeout(function(){
        d.resolve(resp);
      }, 100);

      return d.promise;
    } else {
      return $http.get(SYSSEED_SERVICE_BASE_URL).then(function(response){
        return _search($rootScope.credentials.company.countryIsoCode, response.data.map(item => item.catalog.id), START_PAGE, item, DEFAULT_ROWS);
      });
    }
  };

  // --- private methods ------------------------------------------------------------------------

  /**
   * search the catalog seeds service
   * @param country
   * @param activeSeeds
   * @param locale
   * @param page
   * @param search
   * @param size
   * @returns {*}
   */
  function _search(country, activeSeeds, page, search, size) {
    let req = {
      method: 'POST',
      url: $sce.trustAsResourceUrl(SERVICE_BASE_URL + country + '?page=' + page + '&search=' + search + '&size=' + size),
      data: activeSeeds
    };

    return $http(req)
      .then(function (response) {
          if (response.data) {
            // add needed search string
            response.data.searchString = search;

            // map content list to result list
            response.data.results = response.data.content;
            delete response.data.content;
          }
          return response.data;
        }
      );
  };
};

export default seedSearchService;
